module.exports = __webpack_public_path__ + "img/icon-service.93ea1ac0.svg";